exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.thankyou-wrapper[data-v-296633de] {\n  background: #fcba3e;\n  /* Old browsers */\n  background: -moz-linear-gradient(top, #fcba3e 0%, #f38900 100%);\n  /* FF3.6-15 */\n  background: -webkit-linear-gradient(top, #fcba3e 0%, #f38900 100%);\n  /* Chrome10-25,Safari5.1-6 */\n  background: linear-gradient(to bottom, #fcba3e 0%, #f38900 100%);\n  /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-296633de","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/noomz/Projects/Opendream/kadnud/kadnud-eef-app/src/css"],"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ThankYou.vue
// module id = 575
// module chunks = 1